import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_REFERRAL_BY_EMAIL, SEND_INVITE_VIA_MAIL } from "./customer-referral.mutation";
import { IGetReferralByEmailResponse, ISendInviteResponse } from "./customer-referral.interface";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";
import { useUserCreateStore } from "../../hooks/redux-hooks/user-create-store/user-create.store";
import { IAdvocateReferredStatus } from "./advocate-referral/advocate-referral-interface";
import { ADVOCATE_REFERRAL_STATUS } from "./advocate-referral/advocate-referral-query";


export const useCustomerReferral = () => {
  const { tokenNew, inviteLink, user, referralCode } = useUserStore();
  const { setInviteReferralLink } = useUserCreateStore();
  // Referral Email
  const [getReferralByEmail, { data, loading }] = useMutation<{
    getReferralByEmail: IGetReferralByEmailResponse
  }>(GET_REFERRAL_BY_EMAIL, {
    onCompleted: (data:{getReferralByEmail: IGetReferralByEmailResponse}) => {
      setInviteReferralLink(data.getReferralByEmail.url, data.getReferralByEmail.referralCode);
    },
  });
  // advocate referral status
  const [getAdvocateReferredStatus, { data: advocateData, loading: advocateLoading }] = useLazyQuery<{
      getAdvocateReferredStatus: IAdvocateReferredStatus }>(ADVOCATE_REFERRAL_STATUS, {
        fetchPolicy: "cache-and-network",
      });
  const getReferredStatus = () => {
    getAdvocateReferredStatus();
  };

  const [sendInviteViaEmail, { data: inviteData, loading: inviteLoading }] =
    useMutation<{ sendInviteViaEmail: ISendInviteResponse }>(
      SEND_INVITE_VIA_MAIL,
    );

  const getReferralUrl = () => {
    // invite link is unique for each user, no need to fetch again
    if (inviteLink) return;
    getReferralByEmail({
      variables: {
        email: user?.email || tokenNew?.user?.email,
      },
    });
  };

  const sendInvite = (friendsEmail: string[]) => {
    sendInviteViaEmail({
      variables: {
        email: user?.email || tokenNew?.user?.email,
        friendsEmail: friendsEmail,
      },
    });
  };

  return {
    getReferralUrl,
    referralUrl: inviteLink || data?.getReferralByEmail.url,
    loading,
    sendInvite,
    inviteData: inviteData?.sendInviteViaEmail,
    inviteLoading,
    referralCode,
    // advocate referred status
    getReferredStatus,
    advocateData: advocateData?.getAdvocateReferredStatus,
    advocateLoading,
  };
};
